import { axiosCreate } from "@config/index"
import { verifyBodyResponse } from "@thelpers/verifyBodyResponse"

export const getChargeInstanceDebtorDetail = async ({
    token,
    charge_instance_id,
    place_id
}) => {

    const params = {
        charge_instance_id,
        place_id
    }

    try {
        const res = await axiosCreate.get('/charge/instance/debtor/detail', {
            params,
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })

        return verifyBodyResponse(res, true)
    } catch (error) {
        console.error(error)
        return verifyBodyResponse(error, false)
    }
}